<script setup>

/**
 * 
 * Описанние            - description
 * Версия ПО            - softwareVersion
 * Аппаратная версия    - firmwareVersion
 * 
 */

import { ref, computed, onBeforeUnmount } from 'vue'

import { useTranslaterStore }   from '@/stores/translater'
import { useProfileStore }      from '@/stores/profile'
import { useCarinfoStore }      from '@/stores/car-info'
import { useCmdStore }          from '@/stores/cmd'
import { usePointsStore }       from '@/stores/points'
import { useEcusStore }         from '@/stores/ecus'
import { useEcusDiagStore }     from '@/stores/ecus-diag'
import { useEcusModuleStore }   from '@/stores/ecus-module'

// import Modal                from '@/components/UTAModal.vue'
import UTAGNSSFirmwares      from '@/components/car/ecus/UTAGNSSFirmwares.vue'
import UTAGNSSLogs           from '@/components/car/ecus/UTAGNSSLogs.vue'
// import UTAGNSSParams         from '@/components/car/ecus/UTAGNSSParams.vue'

import errorFlagNames       from '@/helpers/errorFlagNames'
// import strNumToBase64       from '@/helpers/strNumToBase64'
import checkArrayIncludes   from '@/helpers/checkArrayIncludes'

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const translaterStore   = useTranslaterStore()
const profileStore      = useProfileStore()
const carinfoStore      = useCarinfoStore()
const cmdStore          = useCmdStore()
const pointsStore       = usePointsStore()
const ecusStore         = useEcusStore()
const ecusDiagStore     = useEcusDiagStore()
const ecusModuleStore   = useEcusModuleStore()

const getTranslate              = computed(() => translaterStore.getTranslate)
const profile                   = computed(() => profileStore.profile)
const carinfo                   = computed(() => carinfoStore.carinfo)
const executeCmdMsg             = computed(() => cmdStore.executeCmdMsg)
// const sendCmdProcess            = computed(() => cmdStore.sendCmdProcess)
// const sendCmdMsg                = computed(() => cmdStore.sendCmdMsg)
const changeDataServerProcess   = computed(() => cmdStore.changeDataServerProcess)
const rebootGnssProcess         = computed(() => cmdStore.rebootGnssProcess)
const carState                  = computed(() => pointsStore.carState)
const ecu                       = computed(() => ecusStore.ecus.GNSS)
const diagDeleteDTCProcess      = computed(() => ecusDiagStore.diagDeleteDTCProcess)
const diagDeleteDTCMsg          = computed(() => ecusDiagStore.diagDeleteDTCMsg)
const diagRunMsg                = computed(() => ecusDiagStore.diagRunMsg)
const diagRunProcess            = computed(() => ecusDiagStore.diagRunProcess)
// const reports                   = computed(() => ecusDiagStore.reports)
// const reportsProcess            = computed(() => ecusDiagStore.reportsProcess)
// const reportsMsg                = computed(() => ecusDiagStore.reportsMsg)
const ecuModules                = computed(() => ecusModuleStore.ecuModules)

const errors = computed(() => {
    if(ecu.value.report.status !== null) {
        return errorsOnlyActive.value ?
            ecu.value.report.val.filter( error => error.flags.TF === 1) :
            ecu.value.report.val
    }
    return []
})

// сортировка ошибок по tF === 1 - ключ, показывающий активную ошибку
const errorsSorted= computed(() => [...errors.value].sort((prev, cur) => cur.flags.TF - prev.flags.TF))

// const UTACarEcuCmdAct = ref(null)
// const UTACarEcuCmdCmd = ref(null)
// const UTACarEcuCmdData = ref(null)
// const UTACarEcuCmdType = ref(true)
// const UTACarEcuCmdEndian = ref('bigEndian')

// const formCmdInvalid = ref({})
// const formCmdErrors = ref([])

const errorsOnlyActive = ref(false)

// const showEcuHistory = ref(false)
// const pageNumber = ref(1)

// const cmdActs = ref([
//     'No',
//     'Ask',
//     'Set',
//     'Add',
//     'Del'
// ])

// function changePage(cursor, dir) {

//     const params = {
//         uuid_car_array: props.uuid,
//         'c.limit': 6,
//         'c.direction': dir, 
//         'c.cursor': cursor
//     }

//     ecusDiagStore.readReports(params).then(result => {
//         if(result.array) {
//             dir == 'after' ? 
//                 pageNumber.value++ : 
//                 pageNumber.value--
//         }
//     })
// }

// function fetchEcuHistory() {

//     showEcuHistory.value = true
//     pageNumber.value = 1

//     let data = {
//         uuid_car_array: props.uuid,
//         'c.limit': 6
//     }
//     ecusDiagStore.readReports(data)
// }

function tabs(event) {

    const tabsElements = event.target.parentNode.parentNode.childNodes

    for(let tabsBlock of tabsElements) {

        if(tabsBlock.classList.contains('tabs__control')) {

            for(let link of tabsBlock.childNodes) {

                if(link.classList) {

                    link.classList.remove('tabs__link--active')
                }
            }

            event.target.classList.add('tabs__link--active')
        } 

        if(tabsBlock.classList.contains('tabs__body')) {

            for(let tab of tabsBlock.childNodes) {

                if(tab.id == event.target.dataset.target) {

                    if(!tab.classList.contains('tabs__tab--active')) 
                        tab.classList.add('tabs__tab--active')

                } else {

                    if(tab.classList)
                        tab.classList.remove('tabs__tab--active')
                }
            }
        }
    }
}

function cmdServer(event) {

    const serverAddress = event.target.UTACarEcuServer.value

    if(serverAddress) {
        let data = {
            act: 'Set',
            car: props.uuid,
            cmd: 0x0204,
            data: btoa(serverAddress) 
        }
        cmdStore.sendCmd({ type: 'server', data: data })
    }
}

function gnssUptime(value) {

    if(value) {

        const days      = value.days
        const hours     = value.hours
        const minutes   = value.minutes

        return `
            ${ days     ? days      + " " + getTranslate.value.UNIT_DAY       : "" } 
            ${ hours    ? hours     + " " + getTranslate.value.UNIT_HOUR      : "" } 
            ${ minutes  ? minutes   + " " + getTranslate.value.UNIT_MINUTE    : "" } 
        `
    }

    return '–'
}

onBeforeUnmount(() => {
    ecusDiagStore.setDiagRunMsg({})
    cmdStore.setSendCmdMsg({})
    ecusDiagStore.setDiagDeleteDTCMsg({})
})
</script>

<template>

    <div class="uta-car-gnss">

        <header class="page__header uta-header" role="heading" aria-level="1">

            <h1 class="uta-header__title">
                {{ ecu.info.name.toUpperCase() }}
            </h1>

            <div class="uta-header__actions">
                <button 
                    class="uta-btn uta-btn--main uta-btn--sm uta-btn--has-icon uta-header__action uta-header__action--create"
                    :disabled="diagRunProcess"
                    @click="ecusDiagStore.runDiag({ 
                        uuid: props.uuid, 
                        diag: {
                            ecu: 'GNSS_UAZ'
                        }
                    })"
                >
                    <span class="uta-btn__content">
                        <span class="uta-btn__icon material-icons">refresh</span>
                        <span class="uta-btn__text uta-btn__text--has-icon d-none d-md-block">
                            {{ getTranslate.ECU_GNSS_REFRESH }}
                        </span>
                        <div class="spinner-border uta-btn__spinner" role="status" v-if="diagRunProcess">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </span>
                </button>
                <button 
                    v-if="checkArrayIncludes(profile.attr?.array, ['COMMAND', 'SUPER_USER'])"
                    class="uta-btn uta-btn--sm uta-btn--has-icon uta-header__action uta-header__action--create"
                    :disabled="rebootGnssProcess"
                    @click.prevent="cmdStore.executeCmd({ uuid: props.uuid, cmd: 'Reboot' })"
                >
                    <span class="uta-btn__content">
                        <span 
                            class="uta-btn__icon material-icons"
                            :class="{ 'invisible' : rebootGnssProcess }"
                        >
                            loop
                        </span>
                        <span 
                            class="uta-btn__text uta-btn__text--has-icon d-none d-md-block"
                            :class="{ 'invisible' : rebootGnssProcess }"
                        >
                            {{ getTranslate.ECU_GNSS_REBOOT }}
                        </span>
                        <div class="spinner-border btn__spinner" role="status" v-if="rebootGnssProcess">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </span>
                </button>
            </div>

        </header>

        <div class="page__content">

            <div 
                v-if="'success' in diagRunMsg"
                class="mb-4 uta-alert" 
                :class="{
                    'uta-alert--success': diagRunMsg.success,
                    'uta-alert--danger': !diagRunMsg.success
                }"
            >
                <span class="material-icons uta-alert__icon">error_outline</span>
                <div class="uta-alert__text">
                    {{ getTranslate[diagRunMsg.text] || diagRunMsg.text }}
                </div>
                <button type="button" class="uta-alert__close" @click="ecusDiagStore.setDiagRunMsg({})">
                    <span class="material-icons">
                        close
                    </span>
                </button>
            </div>

            <div 
                v-if="'success' in executeCmdMsg"
                class="mb-4 uta-alert" 
                :class="{
                    'uta-alert--success': executeCmdMsg.success,
                    'uta-alert--danger': !executeCmdMsg.success
                }"
            >
                <span class="material-icons uta-alert__icon">
                    {{ executeCmdMsg.success ? 'check_circle_outline' : 'error_outline' }}
                </span>
                <div class="uta-alert__text">
                    {{ getTranslate[executeCmdMsg.text] || executeCmdMsg.text }}
                </div>
                <button type="button" class="uta-alert__close" @click="cmdStore.setExecuteCmdMsg({})">
                    <span class="material-icons">
                        close
                    </span>
                </button>
            </div>

            <div class="tabs mb-4">

                <div class="uta-car-gnss__tabs tabs__control"> 
                    <div 
                        v-if="checkArrayIncludes(profile.attr?.array, ['PARAM', 'COMMAND', 'FIRMWARE', 'SUPER_ADMIN'])"
                        class="uta-car-gnss__tab tabs__link tabs__link--active" 
                        data-target="carEcuInfo" 
                        @click="tabs($event)" 
                    >
                        {{ getTranslate.ECU_INFO }}
                    </div>
                    <div 
                        v-if="checkArrayIncludes(profile.attr?.array, ['PARAM', 'COMMAND', 'FIRMWARE', 'SUPER_ADMIN'])"
                        class="uta-car-gnss__tab tabs__link" 
                        data-target="carEcuModulesInfo" 
                        @click="tabs($event)" 
                    >
                        {{ getTranslate.ECU_MODULES_INFO }}
                    </div>
                    <div 
                        class="uta-car-ecu__tab tabs__link" 
                        :class="{ 'tabs__link--active' : !checkArrayIncludes(profile.attr?.array, ['PARAM', 'COMMAND', 'FIRMWARE', 'SUPER_ADMIN']) }"
                        data-target="carEcuReports" 
                        @click="tabs($event)"
                    >
                        {{ getTranslate.ECU_REPORTS }}
                    </div>
                    <div class="uta-car-ecu__tab tabs__link" 
                        data-target="carEcuErrors" 
                        @click="tabs($event)"
                    >
                        {{ getTranslate.ECU_ERRORS }} <span class="tabs__link-icon" v-if="ecu.report.val.length"></span>
                    </div>
                    <div class="uta-car-gnss__tab tabs__link" 
                        data-target="carEcuSoftwares" 
                        @click="tabs($event)" 
                        v-if="checkArrayIncludes(profile.attr?.array, ['FIRMWARE', 'SUPER_ADMIN'])"
                    > 
                        {{ getTranslate.ECU_GNSS_FIRMWARES }}
                    </div>
                    <div 
                        class="uta-car-gnss__tab tabs__link" 
                        data-target="carEcuLogs" 
                        @click="tabs($event)" 
                        v-if="checkArrayIncludes(profile.attr?.array, ['LOGS_CAR', 'SUPER_ADMIN'])"
                    >
                        {{ getTranslate.ECU_GNSS_LOGS }}
                    </div>
                    <!-- <div class="uta-car-gnss__tab tabs__link" data-target="carEcuParams" @click="tabs($event)" v-if="checkArrayIncludes(profile.attr?.array, ['PARAM', 'SUPER_ADMIN'])">
                        {{ getTranslate.ECU_PARAMS }}
                    </div> -->
                </div>

                <div class="tabs__body">

                    <div 
                        v-if="checkArrayIncludes(profile.attr?.array, ['PARAM', 'COMMAND', 'FIRMWARE', 'SUPER_ADMIN'])"
                        class="uta-car-gnss__info tabs__tab tabs__tab--active mt-4" 
                        id="carEcuInfo"
                    >
                        <div class="row">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                <div class="uta-car-gnss__info-item">
                                    <div class="uta-car-gnss__info-item-title">{{ getTranslate.ECU_GNSS_UPDATE_PARAMS }}</div>
                                    <div class="uta-car-gnss__info-item-value">{{ carState.last_can_param_time.value !== null ? carState.last_can_param_time.value : '-' }}</div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                <div class="uta-car-gnss__info-item">
                                    <div class="uta-car-gnss__info-item-title">{{ getTranslate.ECU_GNSS_UPDATE_NAVI }}</div>
                                    <div class="uta-car-gnss__info-item-value">{{ carState.last_navigation_time.value || '–' }}</div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                <div class="uta-car-gnss__info-item">
                                    <div class="uta-car-gnss__info-item-title">{{ getTranslate.ECU_GNSS_TID }}</div>
                                    <div class="uta-car-gnss__info-item-value">{{ carinfo.data?.tid || '–' }}</div>
                                </div>
                            </div>
                            <!-- Время последнего выхода на связь -->
                            <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4" v-if="carState.online.value === 0">
                                <div class="uta-car-gnss__info-item">
                                    <div class="uta-car-gnss__info-item-title">{{ getTranslate.ECU_GNSS_ONLINE_DATE }}</div>
                                    <div class="uta-car-gnss__info-item-value">{{ carState.last_online?.value || '–' }}</div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                <div class="uta-car-gnss__info-item">
                                    <div class="uta-car-gnss__info-item-title">{{ getTranslate.STATE_SDM_UPTIME }}</div>
                                    <div class="uta-car-gnss__info-item-value">{{ gnssUptime(carState.sdm_uptime.value || false) }}</div>
                                </div>
                            </div>
                        </div> 

                        <template v-if="checkArrayIncludes(profile.attr?.array, ['SUPER_ADMIN', 'FIRMWARE'])">
                            <h4 class="my-4">{{ getTranslate.ECU_GNSS_DEBUG_PARAMS }}</h4>
                            <div class="row">
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">ANS1</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.ANS1.value !== null ? carState.ANS1.value : '-' }}</div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">ANS2</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.ANS2.value !== null ? carState.ANS2.value : '-' }}</div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">ANS3</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.ANS3.value !== null ? carState.ANS3.value : '-' }}</div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">ANS4</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.ANS4.value !== null ? carState.ANS4.value : '-' }}</div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">ANS5</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.ANS5.value !== null ? carState.ANS5.value : '-' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">DIG1</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.DIG1.value !== null ? carState.DIG1.value : '-' }}</div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">DIG2</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.DIG2.value !== null ? carState.DIG2.value : '-' }}</div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">DIG3</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.DIG3.value !== null ? carState.DIG3.value : '-' }}</div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">DIG4</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.DIG4.value !== null ? carState.DIG4.value : '-' }}</div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-4 col-lg-6 col-xl-4">
                                    <div class="uta-car-gnss__info-item">
                                        <div class="uta-car-gnss__info-item-title">DIG5</div>
                                        <div class="uta-car-gnss__info-item-value">{{ carState.DIG5.value !== null ? carState.DIG5.value : '-' }}</div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-if="checkArrayIncludes(profile.attr?.array, ['COMMAND', 'SUPER_ADMIN'])">
                            <hr>
                            <div class="mb-5 uta-car-gnss__telematic">
                                <h4 class="mt-4">{{ getTranslate.ECU_GNSS_TELEMATIC }}</h4>
                                <div class="mt-2 uta-btns">
                                    <button class="uta-btn" @click.prevent="cmdStore.executeCmd({ uuid: props.uuid, telematics: { value: 'ON' } })">{{ getTranslate.ECU_GNSS_TELEMATIC_ON }}</button>
                                    <button class="uta-btn" @click.prevent="cmdStore.executeCmd({ uuid: props.uuid, telematics: { value: 'OFF' } })">{{ getTranslate.ECU_GNSS_TELEMATIC_OFF }}</button>
                                </div>
                            </div>
                        </template>

                        <form class="mb-5 uta-car-gnss__server" @submit.prevent="cmdServer($event)" v-if="checkArrayIncludes(profile.attr?.array, ['PARAM', 'SUPER_ADMIN'])">
                            <div class="row">
                                <div class="col">
                                    <h4 class="mt-4 mb-2">{{ getTranslate.ECU_GNSS_SET_SERVER }}</h4>
                                    <div class="uta-car-gnss__server-input">
                                        <input type="text" id="UTACarEcuServer" placeholder="https://..." class="form-control">
                                    </div>
                                    <button 
                                        :disabled="changeDataServerProcess"
                                        class="my-4 uta-btn uta-btn--main uta-car-gnss__server-send" 
                                        type="submit"
                                    >
                                        <div сlass="uta-btn__text">
                                            {{ getTranslate.BTN_SEND }}
                                        </div>
                                        <div class="spinner-border uta-btn__spinner" role="status" v-if="changeDataServerProcess">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>

                    <div 
                        class="uta-car-gnss__info tabs__tab mt-4" 
                        :class="{ 'tabs__tab--active' : !checkArrayIncludes(profile.attr?.array, ['PARAM', 'COMMAND', 'FIRMWARE', 'SUPER_ADMIN']) }"
                        id="carEcuReports"
                    >
                        <div class="uta-car-gnss__dids">
                            <div class="uta-car-gnss__did-timestamp my-4">
                                {{ getTranslate.ECU_TIMESTAMP }}: {{ ecu.info.timeStamp ? new Date(ecu.info.timeStamp * 1000).toLocaleString() : '–' }}
                            </div>
                            <template v-if="'did' in ecu.report && ecu.report.did.length">
                                <div class="uta-car-gnss__did" v-for="(did, index) in ecu.report.did" :key="index">
                                    <div class="row">
                                        <div class="col-3 col-md-2 col-lg-2">
                                            <div class="uta-car-gnss__did-did">
                                                {{ did.did }}
                                            </div>
                                        </div>
                                        <div class="col-9 col-md-5 col-lg-5">
                                            <div class="uta-car-gnss__did-name">
                                                {{ did.name }}
                                            </div>
                                        </div>
                                        <div class="mt-3 mt-md-0 col-12 col-md-5 col-lg-5">
                                            <div class="uta-car-gnss__did-value">

                                                <template v-if="did.response == 'false'">
                                                    <span class="uta-car-gnss__did-value-fail">No positive response</span>
                                                </template>

                                                <template v-else-if="did.response == 'true' && did.value == null">
                                                    <div class="uta-car-gnss__did-value-epicfail">Data parsing error</div>
                                                </template>

                                                <template v-else>
                                                    {{ did.value }}
                                                </template>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                {{ getTranslate.ECU_PARAMS_NO_INFO }}
                            </template>
                        </div>
                    </div>

                    <div class="uta-car-gnss__errors tabs__tab mt-4" id="carEcuErrors">
                        <div class="switcher uta-car-gnss__errors-filter">
                            <input class="switcher__input uta-car-gnss__errors-filter-input" type="checkbox" id="UTAEcuFilter" v-model="errorsOnlyActive" :checked="errorsOnlyActive">
                            <label class="switcher__label uta-car-gnss__errors-filter-label" for="UTAEcuFilter">
                                <span class="switcher__text">{{ getTranslate.ECU_ERRORS_ONLY_ACTIVE }}</span>
                            </label>
                        </div>
                        <template v-if="errorsSorted.length">
                            <div id="gnssAccordion">
                                <div
                                    v-for="(error, index) in errorsSorted" 
                                    :key="error.code"
                                    class="uta-car-gnss__errors-item"
                                    :class="{ 'uta-car-gnss__errors-item--active' : error.flags.TF === 1 }"
                                >
                                    <div 
                                        class="collapsed uta-car-gnss__errors-item-header"
                                        :id="'gnssAccordion_collapse_' + index"
                                        data-bs-toggle="collapse" 
                                        :data-bs-target="'#collapse' + index" 
                                        aria-expanded="false" 
                                        :aria-controls="'collapse' + index"
                                    >
                                        <div class="row uta-car-gnss__errors-item-body">
                                            <div class="col-10 col-md-2 col-lg-11 col-xl-2">
                                                <div class="uta-car-gnss__errors-item-title">{{ error.value }}</div>
                                            </div>
                                            <div class="col-10 col-md-9 col-lg-11 col-xl-9">
                                                <div class="uta-car-gnss__errors-item-value">{{ error.longName }}</div>
                                            </div>
                                            <span class="material-icons">
                                                expand_less
                                            </span>
                                        </div>
                                        <div 
                                            :id="'collapse' + index" 
                                            class="collapse" 
                                            :aria-labelledby="'gnssAccordion_collapse_' + index" 
                                            data-bs-parent="#gnssAccordion"
                                        >
                                            <div
                                                v-for="(value, name, index) in error.flags"
                                                :key="name"
                                                class="uta-car-gnss__errors-subitem" :class="{ 'uta-car-gnss__errors-subitem--grey' : index % 2 === 0 }"
                                            >
                                                <div class="row">
                                                    <div class="col-10 col-md-2">
                                                        {{ errorFlagNames[name]['title'] }}
                                                    </div>
                                                    <div class="col-1 text-end text-md-start">
                                                        {{ value }}
                                                    </div>
                                                    <div class="col-10 col-md-8">
                                                        {{ errorFlagNames[name][value] }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div 
                                v-if="'success' in diagDeleteDTCMsg"
                                class="my-4 uta-alert uta-car-ecus__message"
                                :class="{
                                    'uta-alert--success': diagDeleteDTCMsg.success,
                                    'uta-alert--danger': !diagDeleteDTCMsg.success
                                }"
                            >
                                <span class="material-icons uta-alert__icon">
                                    {{ 
                                        diagDeleteDTCMsg.success ? 
                                            'check_circle_outline' : 
                                            'error_outline' 
                                    }}
                                </span>
                                <span class="alert__text">{{ diagDeleteDTCMsg.text }}</span>
                                <button type="button" class="btn-close uta-alert__close" @click="ecusDiagStore.setDiagDeleteDTCMsg({})"></button>
                            </div>
                            <div class="uta-btns my-4">
                                <button
                                    href="#" 
                                    class="uta-btn uta-btn--sm uta-btn--has-icon"
                                    :disabled="diagDeleteDTCProcess"
                                    @click="ecusDiagStore.deleteDiagDTC({ 
                                        uuid: props.uuid, 
                                        clear: {
                                            ecu: 'GNSS_UAZ' 
                                        }
                                    })"
                                >
                                    <div class="uta-btn__content">
                                        <span class="material-icons">
                                            delete
                                        </span>
                                        <div class="uta-btn__text">
                                            {{ getTranslate.CAR_ECUS_REPORTS_DELETE }}
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </template>
                        <template v-else>
                            <template v-if="ecu.report.status == null && ecu.installed">
                                <span :style="{'color': '#FF0000'}">No positive response</span>
                            </template>
                            <template v-else>
                                {{ getTranslate.ECU_ERRORS_EMPTY }}
                            </template>
                        </template>
                    </div>

                    <div class="tabs__tab mt-4" id="carEcuSoftwares">
                        <UTAGNSSFirmwares :uuid="props.uuid" />
                    </div>

                    <div class="tabs__tab mt-4" id="carEcuLogs">
                        <UTAGNSSLogs :uuid="props.uuid" />
                    </div>

                    <div 
                        v-if="checkArrayIncludes(profile.attr?.array, ['PARAM', 'COMMAND', 'FIRMWARE', 'SUPER_ADMIN'])"
                        class="uta-car-gnss__info tabs__tab mt-4" 
                        id="carEcuModulesInfo"
                    >
                        <template v-if="ecuModules.array?.length">
                            <div 
                                class="uta-car-gnss__info-module"
                                v-for="(module, index) in ecuModules.array" 
                                :key="index"
                            >
                                <h3 class="my-4">{{ getTranslate[module.name] || '–' }}</h3>
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                        <div class="uta-car-gnss__info-item">
                                            <div class="uta-car-gnss__info-item-title">{{ getTranslate.ECU_GNSS_DESCR }}</div>
                                            <div class="uta-car-gnss__info-item-value">{{ module.description || '–' }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                        <div class="uta-car-gnss__info-item">
                                            <div class="uta-car-gnss__info-item-title">{{ getTranslate.ECU_GNSS_SOFTWARE }}</div>
                                            <div class="uta-car-gnss__info-item-value">{{ module.softwareVersion || '–' }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                        <div class="uta-car-gnss__info-item">
                                            <div class="uta-car-gnss__info-item-title">{{ getTranslate.ECU_GNSS_CREATE_DATE }}</div>
                                            <div class="uta-car-gnss__info-item-value">{{ module.firmwareVersion || '–' }}</div>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </template>
                        <template v-else>
                            {{ getTranslate.ECU_MODULES_INFO_EMPTY }}
                        </template>
                    </div>

                    <!-- <div class="tabs__tab mt-4" id="carEcuParams">
                        <UTAGNSSParams :uuid="props.uuid" />
                    </div> -->

                </div>
            </div>
        </div>
    </div>

</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/ecus/ecus-gnss.scss';
</style>